import { styles } from './template.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { renderErrorStateIcon } from '../../utils/widgets.utils';

export const templateRemediations = document.createElement('template');

templateRemediations.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper widget-2-3-ratio">
    <h2 class="widget-title display-2">
        <span id="remediationActionsTitle"></span>
        ${renderErrorStateIcon()}
    </h2>

    <div class="content">
        <div id="textWidthMeasurer"></div>
        <div id="remediationActionsChart" class="remediation-chart"></div>
        <gz-loader class="widget-loading" rows="5"></gz-loader>
     </div>
  </div>
`;
